import { UserConfig, UserInfo } from '../types/UserConfig';
import { UserRoles } from '../types/UserRoles';

export function getUserAvatarData(
    user?: UserInfo,
    users?: UserInfo[],
    userName?: string | undefined | null,
) {
    let theUser = user ? user : users?.find(x => x.userName === userName);

    const firstName = theUser?.firstName || '';
    const lastName = theUser?.lastName || '';

    return {
        initials: getUserAvatarInitials(firstName, lastName, userName),
        tooltip: theUser
            ? `${(firstName + ' ' + lastName).trim()} \u00B7 ${theUser.userName}`
            : userName,
        background: theUser?.colour || 'grey',
    };
}

export function getUserAvatarInitials(
    firstName: string | undefined | null,
    lastName: string | undefined | null,
    userName: string | undefined | null,
) {
    let fInitial = firstName?.charAt(0).toUpperCase() || '';
    let lName = lastName?.charAt(0).toUpperCase() || '';

    //fallback to username if no name is provided
    if (!fInitial && !lName) fInitial = userName?.charAt(0)?.toUpperCase() || '';

    //splits the lastname from the firstname in case user enters entire name in first field
    if (!lName) {
        if (fInitial && fInitial.indexOf(' ') > -1) {
            const splits = fInitial.split(' ');
            if (splits.length > 0) lName = splits[splits.length - 1]?.charAt(0) || '';
        }
    }

    return fInitial + lName;
}

export function isUserInRole(usersRoles: UserRoles[], rolesToCheck: UserRoles[]) {
    //console.log('isUserInRole', usersRoles, rolesToCheck);
    return usersRoles.some(r => rolesToCheck.includes(r));
}

export function getUserFullName(userConfig: UserConfig | undefined) {
    return `${userConfig?.userFirstName} ${userConfig?.userLastName}`.trim();
}
